import * as React from 'react';

import { DropdownItem } from 'reactstrap';

import { PageAction } from './Page';
import { History } from 'history';

interface PageDropdownProps {
  action: PageAction;
  history?: History;
  testId?: string;
}

export class PageDropdownItem extends React.Component<PageDropdownProps> {
  handleClick = () => {
    const { action, history } = this.props;
    if (action.onClick) {
      action.onClick();
    } else if (action.to && history) {
      history.push(action.to);
    }
  };

  render() {
    const { action, testId } = this.props;
    return (
      <DropdownItem onClick={this.handleClick} href={action.href} data-testid={testId}>
        {action.iconName && (
          <span style={{ width: 32 }}>
            <i className={`fa fa-${action.iconName}`} style={{ width: 32 }} />
          </span>
        )}
        {action.label}
      </DropdownItem>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/layout/Page/PageDropdownItem.tsx